// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';

// App code

jQuery('.nav-link').on('click', function() {
    jQuery(this).closest('.navbar-collapse').removeClass('show');
});

jQuery(".next-btn:not([data-role='tab']):not(.nojs)").on('click', function(event) {
    jQuery('.produktfinder')[0].scrollIntoView({behavior: 'smooth'});
    if(event.handled === false) return
        event.stopPropagation();
        event.preventDefault();
        event.handled = true;
    var closest_step = jQuery(this).closest('.step');
    closest_step.hide();
    if(jQuery(this).hasClass('no-icon')) {
        jQuery('.step-4').fadeIn('slow');
        var contact_image = jQuery(this).find('.contact-image').attr('src');
        var contact_info = jQuery(this).find('.contact-info').html();
        jQuery('.step-4').find('.contact-image').attr('src', contact_image);
        jQuery('.step-4').find('.contact-info').html(contact_info);
        jQuery('.step-4').find('.product-properties').hide();
    } else {
        closest_step.next().fadeIn('slow');
        var category = jQuery(this).attr('data-category');
        var category_split = jQuery(this).attr('data-category').split(' ');
        var category_2 = category_split[1];
        closest_step.next().find('.' + category).removeClass('d-none').addClass('d-show');
        closest_step.next().find('.' + category_2).removeClass('d-none').addClass('d-show');
        if(closest_step.hasClass('step-3')) {
            var contact_image = jQuery(this).find('.contact-image').attr('src');
            var contact_info = jQuery(this).find('.contact-info').html();
            var properties_image = jQuery(this).find('.product-properties-image').attr('src');
            var properties_title = jQuery(this).find('.product-properties-title').html();
            var product_properties = jQuery(this).find('.product-properties').html();
            closest_step.next().find('.contact-image').attr('src', contact_image);
            closest_step.next().find('.contact-info').html(contact_info);
            closest_step.next().find('.product-properties-image').attr('src', properties_image);
            closest_step.next().find('.product-properties-title').html(properties_title);
            closest_step.next().find('.product-properties').append(product_properties);
            console.log(properties_image+' '+properties_title+' '+product_properties);
        }
        console.log(properties_image);
    }
    $.ajax({
        type: 'POST',
        data: 'category=' + category
      });
});

jQuery(".next-btn[data-role='tab']").on('click', function() {
    var target = jQuery(this).attr('data-target');
    jQuery('.tab-pane').removeClass('active');
    jQuery('.next-btn').removeClass('active');
    jQuery('.tab-pane').removeClass('show');
    jQuery(target).addClass('show');
    jQuery(target).addClass('active');
    jQuery(this).addClass('active');
    //if ($(window).width() < 1200) {
        jQuery('html').animate({
          scrollTop: $(".tab-content").offset().top
            },800
        );
    //}
});

jQuery(".back-btn").on('click', function() {
    jQuery(this).closest('.step').hide();
    jQuery(this).closest('.step').hide();
    jQuery('.step-1').fadeIn('slow');
    jQuery('.produktfinder')[0].scrollIntoView({behavior: 'smooth'});
    jQuery('.d-show').removeClass('d-show').addClass('d-none');
    jQuery('.step-4 .product-properties-list').remove();
    jQuery('.step-4').find('.product-properties').show();
});